module.exports = __webpack_public_path__ + "static/media/create-pin.d9410862.svg";